/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Instructions_Discard_KeepInputs */



/**
* | output |
* | --- |
* | "Keep editing" |
*
* @param {Project_Instructions_Discard_KeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_instructions_discard_keep = /** @type {((inputs?: Project_Instructions_Discard_KeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Instructions_Discard_KeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weiter bearbeiten")
	return /** @type {LocalizedString} */ ("Keep editing")
});